module.exports = __webpack_public_path__ + "img/close2.23b0a466.png";